"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PACKAGE_KEYS = void 0;
exports.packageValues = packageValues;
const finance_1 = require("./finance");
/**
 * The package provider's key space — the SOFTWARE a deal sells, the counterpart
 * to `device` on the hardware side.
 *
 * Adding a key here and not producing it in `packageValues` is a COMPILE ERROR
 * (that function `satisfies Record<PackageKey, string | undefined>`).
 *
 * Singular keys follow the same rule as the device provider: `name`,
 * `monthly_price`, `feature_list` and `limits` describe ONE package, so on a
 * deal carrying several they return `undefined` rather than assert the first
 * one. `name_list`, `count` and `monthly_total` are the multi-package answers
 * and always resolve — a sentence naming every package is truthful where a
 * sentence naming one is not.
 */
exports.PACKAGE_KEYS = [
    'name', 'name_list', 'monthly_price', 'feature_list', 'limits',
    'count', 'monthly_total',
];
function packageValues(lines) {
    const only = lines.length === 1 ? lines[0] : undefined;
    const monthlyTotalCents = lines.reduce((sum, l) => sum + (l.monthlyPriceCents ?? 0) * (l.quantity ?? 1), 0);
    return {
        name: only?.name,
        name_list: lines.length ? lines.map((l) => l.name).join(', ') : undefined,
        monthly_price: typeof only?.monthlyPriceCents === 'number' ? (0, finance_1.dollars)(only.monthlyPriceCents) : undefined,
        feature_list: only?.features?.length ? only.features.join(', ') : undefined,
        limits: only?.limits,
        count: String(lines.length),
        monthly_total: lines.length ? (0, finance_1.dollars)(monthlyTotalCents) : undefined,
    };
}
//# sourceMappingURL=packages.js.map